import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Typography } from '@material-ui/core'

import { DashboardCounterCard } from 'components'

import {
  MySuppliersCompliance,
  SupplierComplianceTable,
  SupplierQuestionnaireProgress,
} from 'components/DashboardSupplier'

import helpers from 'helpers'
import constants from 'constants/index'

const DashboardSupplier = ({ supplierStats }) => {
  const { suppliers: supplierIds } = constants.myLgpd.GRAPH_IDS

  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h4" color="primary">
          Fornecedores
        </Typography>
      </Grid>
      <Grid item xs={12} lg={6}>
        <MySuppliersCompliance supplierStats={supplierStats} />
      </Grid>
      <Grid item xs={12} lg={6}>
        <SupplierQuestionnaireProgress supplierStats={supplierStats} />
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={3} id={supplierIds?.cardStats}>
          <DashboardCounterCard
            label="Meus fornecedores"
            value={supplierStats?.suppliers?.length}
          />
          <DashboardCounterCard
            label="Sou fornecedor"
            value={supplierStats?.providingCount}
          />
        </Grid>
      </Grid>
      <Grid item xs={12} md={6} id={supplierIds?.highCompliancers}>
        <SupplierComplianceTable
          title="Fornecedores com boa conformidade"
          subtitle="Acompanhe os seus fornecedores"
          suppliers={helpers.myLgpd.getSupplierByCompliance(
            supplierStats,
            51,
            101,
          )}
        />
      </Grid>
      <Grid item xs={12} md={6} id={supplierIds?.lowCompliancers}>
        <SupplierComplianceTable
          title="Fornecedores com baixa conformidade"
          subtitle="Acompanhe os seus fornecedores"
          suppliers={helpers.myLgpd.getSupplierByCompliance(
            supplierStats,
            0,
            50.99,
            'desc',
          )}
        />
      </Grid>

      <Grid item xs={12}>
        <Typography variant="h4" color="primary">
          Pré-Avaliados
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={3}>
          <DashboardCounterCard
            label="Meus pré-avaliados"
            value={supplierStats?.preAvaliatedSuppliers?.length ?? 0}
          />
          <DashboardCounterCard
            label="Sou pré-avaliado"
            value={supplierStats?.preAvaliatedProvidingCount ?? 0}
          />
        </Grid>
      </Grid>

      <Grid item xs={12} md={6}>
        <SupplierComplianceTable
          title="Pré-avaliados com boa conformidade"
          subtitle="Acompanhe os seus pré-avaliados"
          suppliers={helpers.myLgpd.getPreAvaliatedSupplierByCompliance(
            supplierStats,
            51,
            101,
          )}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <SupplierComplianceTable
          title="Pré-avaliados com baixa conformidade"
          subtitle="Acompanhe os seus pré-avaliados"
          suppliers={helpers.myLgpd.getPreAvaliatedSupplierByCompliance(
            supplierStats,
            0,
            50.99,
            'desc',
          )}
        />
      </Grid>
    </>
  )
}

DashboardSupplier.propTypes = {
  supplierStats: PropTypes.object,
}

export default DashboardSupplier
